import { Injectable } from '@angular/core'
import { SignupAttributes } from '~app/services/authentication/contracts/signup-attributes'

@Injectable()
export class SignupAttributesService {
  attributes: SignupAttributes | undefined
}
